import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { checkAgeRestriction } from "./onboardingCheck";
import { Capacitor } from "@capacitor/core";

function OnboardingRoute({ children }) {
  const { currentUserState, loading } = useAuth();
  const [isUnder17, setIsUnder17] = useState(false);
  const [checkingAge, setCheckingAge] = useState(false);

  // Check age restriction when user state changes
  useEffect(() => {
    const checkAgeRestrictionStatus = async () => {
      if (!currentUserState || loading) {
        setIsUnder17(false);
        setCheckingAge(false);
        return;
      }

      setCheckingAge(true);
      try {
        const isAgeRestricted = await checkAgeRestriction(currentUserState);
        setIsUnder17(isAgeRestricted);
      } catch (error) {
        console.error("Error checking age restriction:", error);
        setIsUnder17(false);
      } finally {
        setCheckingAge(false);
      }
    };

    checkAgeRestrictionStatus();
  }, [currentUserState, loading]);

  // Check if user is on web platform - if so, redirect to download page
  const isWebPlatform = !Capacitor.isNativePlatform();

  if (isWebPlatform) {
    return <Navigate to="/download" />;
  }

  if (loading || checkingAge) {
    return null;
  }

  if (!currentUserState) {
    return <Navigate to="/login" />;
  }

  // Check age restriction first
  if (isUnder17) {
    return <Navigate to="/age-restriction" />;
  }

  return children;
}

export default OnboardingRoute;
